import { useEffect, useState } from "react";
import axios from "axios";
import { E_immatriculation } from "../../../../constants/constant";
import Label from "../../../../components/title/label";
import Input from "../../../../components/input/Input";
import Table from "../../../../components/table/Table";

import { Navbar } from "../../../../components/navbar/Navbar";
import BackButton from "../../../../components/button/BackButton";

function VehiculeContribuable() {
 

    // const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    // const [DataSelected , setDataSelected] = useState([]);
    const [searchTerm, setSearchTerm] = useState("")
  
   
    const [Data , setData] = useState([])

   
useEffect(() => {
 // Récupérer les données depuis le backend
 axios.get(`${E_immatriculation}/vehicle`)
   .then((response) => setData(response.data))
   .catch((error) => console.error(error));
}, []);

console.log("vehicule" , Data)
const headers = ["ID Contribuable","Numéro immatriculattion", "Marque", "Puissance", "Poids à vide "];
// const data = Data.map((item : any )=>[item.numero_immatriculation  ,item.marque ,  item.puissance , item.poids_a_vide])

const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
const [contribuableData] = useState(JSON.parse(selectedData));

const filteredData  = Data.filter ((item)=>
    item.id_contribuable === contribuableData.id
&& item.numero_immatriculation 
&& item.numero_immatriculation.toLowerCase().includes(searchTerm.toLowerCase())
);

const data = filteredData ? filteredData.map((item)=>
[
 item.id_contribuable ,
 item.numero_immatriculation,
 item.marque ,
 item.puissance,
 item.poids_a_vide

]) : [["aucune" , "aucune" , "aucune" , "aucune" , "aucune"]];

const handleSearch = (e) => {
 setSearchTerm(e.target.value);
};


// selection data 


// const [isStorageUpdated, setIsStorageUpdated] = useState(false);

// useEffect(() => {
//  // Store Value data in localStorage
//  localStorage.setItem("selectedContribuableRectificationAddVehicule", JSON.stringify(DataSelected ));
//  // Reset the dummy state to trigger rerender
//  console.log(DataSelected)
//  setIsStorageUpdated(false);
// }, [DataSelected, isStorageUpdated]);

// const handleButtonClick = () => {


//     // Vérifier si des données sont sélectionnées
//     if (!DataSelected || Object.keys(DataSelected).length === 0) {
//       alert("Veuillez sélectionner un véhicule avant de continuer");
//       return;
//     }


//  // Trigger a rerender by updating the dummy state
//  setIsStorageUpdated(true);

//  // Use the selectedOption to determine the route to navigate to
//  const routeToNavigate = "/InfoVehicule";

//  // Use navigate to navigate to the determined route
//  navigate(routeToNavigate, { state: { DataSelected } });
// };

// const handleTableRowClick = (rowIndex: any) => {
//     // Si la ligne cliquée est déjà sélectionnée, on désélectionne
//     if (selectedRowIndex === rowIndex) {
//         setSelectedRowIndex(null);
//         setDataSelected([]);
//     } 
//     // Sinon, on sélectionne la nouvelle ligne
//     else {
//         setSelectedRowIndex(rowIndex);
//         const selectedRowData = Data[rowIndex];
//         setDataSelected(selectedRowData);
//     }
    
//     console.log('Selected Row Data:', DataSelected);
// };


    // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className="text-white">
            Véhicule
     </div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
 return (
     <div className="w-full bg-[#212122] h-screen">
          <Navbar content={contentNavbar} />
          <main className="">   <div >

<div className="flex justify-center items-center mt-4 p-6" >
<div className="mt-4 flex flex-col mx-6">
 
<div className="text-white text-2xl  font-semibold  text-center  mt-2"> DES VEHICULES SUR CONTRIBUABLE </div>

        
   {/**card recherche  */} 
            <div className="mt-6 flex  justify-center ">
                       <Label text="Numero Immatriculation" className="mt-2" ></Label>
                       <Input type="text" className="w-96 ml-5 "placeholder="N° Immatriculation EX: 3004 TBA" onChange={handleSearch}></Input>
  
                   </div>


<div className="mt-8 overflow-y-auto flex justify-center">
<Table className="border-x-2  w-[1000px]"
headers={headers}
data={data}

// onClick={handleTableRowClick}
// selectedRowIndex={selectedRowIndex}

></Table>
</div>
<div>
 
 <div className="flex justify-between p-4">
    {/* <Button
    text="Voir le vehicule"
    onClick={handleButtonClick}
    ></Button> */}

 </div>
</div>
</div>
       </div>
       </div></main>
        </div>
 )
}


export default VehiculeContribuable